export const checkRoles = (user) => {
  const roles = user?.roles || [];
  const hasLocation =
    !!user?.location ||
    (Array.isArray(user?.locations) && user.locations.length > 0);
  const hasDivision =
    !!user?.division ||
    (Array.isArray(user?.divisions) && user.divisions.length > 0);
  const hasLevel =
    !!user?.level || (Array.isArray(user?.levels) && user.levels.length > 0);

  return {
    isSystemAdmin: roles.some((role) => role.name === "System Admin"),
    isOrgAdmin: roles.some((role) => role.name === "Trust Admin"),
    isLocationAdmin:
      roles.some((role) => role.name === "Headteacher") && hasLocation,
    isDivisionAdmin:
      roles.some((role) => role.name === "Head of Subject") && hasDivision,
    isLevelAdmin:
      roles.some((role) => role.name === "Head of Year") && hasLevel,
    isSeniorLeader: roles.some(
      (role) => role.name === "Senior Leadership Team"
    ),
    isAcademyImprovementLead: roles.some(
      (role) => role.name === "Academy Improvement Lead"
    ),
  };
};

export const getPermissionFlags = (user) => {
  const {
    isSystemAdmin,
    isOrgAdmin,
    isLocationAdmin,
    isDivisionAdmin,
    isLevelAdmin,
    isSeniorLeader,
  } = checkRoles(user);

  return {
    isAnyAdmin:
      isSystemAdmin ||
      isOrgAdmin ||
      isLocationAdmin ||
      isDivisionAdmin ||
      isLevelAdmin,
    showOrg: isOrgAdmin || isSystemAdmin,
    showLocation: isSystemAdmin || isOrgAdmin || isLocationAdmin,
    showSeniorLeader:
      isSystemAdmin || isOrgAdmin || isLocationAdmin || isSeniorLeader,
    showDivision:
      isSystemAdmin || isOrgAdmin || isLocationAdmin || isDivisionAdmin,
    showLevel: isSystemAdmin || isOrgAdmin || isLocationAdmin || isLevelAdmin,
  };
};

// Collect all scoped ids (single + multi) for downstream filtering
export const getUserScope = (user = {}) => {
  const toId = (val) => {
    if (!val) return null;
    if (typeof val === "string") return val;
    if (val._id) return val._id;
    return null;
  };

  const dedupe = (arr = []) => [...new Set(arr.filter(Boolean))];

  const organisationId = toId(user.organisation);
  const locationIds = dedupe([
    toId(user.location),
    ...(Array.isArray(user.locations) ? user.locations.map(toId) : []),
  ]);
  const divisionIds = dedupe([
    toId(user.division),
    ...(Array.isArray(user.divisions) ? user.divisions.map(toId) : []),
  ]);
  const levelIds = dedupe([
    toId(user.level),
    ...(Array.isArray(user.levels) ? user.levels.map(toId) : []),
  ]);

  return { organisationId, locationIds, divisionIds, levelIds };
};
